import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/components/site/Landing';
import Legal from '@/components/site/Legal';
import Privacy from '@/components/site/Privacy';
import NotFound from '@/components/common/NotFound';

Vue.use(Router);

export default new Router({
   routes: [
      {
         path: '/',
         name: 'Landing',
         component: Landing
      },
      {
         path: '/e/:eid',
         name: 'Entry',
         component: Landing
      },
      {
         path: '/t/:topic',
         name: 'Topic',
         component: Landing
      },      
      {
         path: '/legal',
         name: 'Legal',
         component: Legal
      },
      {
         path: '/privacy',
         name: 'Privacy',
         component: Privacy
      },
      {  
         path: '*',
         name: 'NotFound',
         component: NotFound
      }
   ],
   mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js